var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsContributorReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M68.20996,45.40576c-.82861,0-1.5.67139-1.5,1.5,0,3.36938-2.41687,8.70129-7.00598,15.50922-1.31384-4.09772-5.13751-7.07318-9.66589-7.08997,3.23798-.02075,5.85693-2.65021,5.85693-5.89307,0-3.25574-2.63928-5.89502-5.89502-5.89502s-5.89502,2.63928-5.89502,5.89502c0,3.24286,2.61896,5.87231,5.85693,5.89307-4.52844.01678-8.35217,2.99231-9.66589,7.09015-4.58923-6.80841-7.00598-12.14008-7.00598-15.5094,0-.82861-.67139-1.5-1.5-1.5s-1.5.67139-1.5,1.5c0,4.47314,3.14209,11.13916,9.34033,19.81299,1.39307,1.94531,2.90625,3.94531,4.49805,5.94434,1.43457,1.80078,3.57471,2.83301,5.87158,2.83301s4.43701-1.03223,5.87158-2.83301c1.5918-1.99902,3.10498-3.99902,4.49854-5.94531,6.19775-8.67285,9.33984-15.33887,9.33984-19.81201,0-.82861-.67139-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M54.8064,30.21606l-2.74976-.5495-1.37225-2.44531c-.29987-.53424-1.06891-.53424-1.36871,0l-1.37231,2.44531-2.74969.5495c-.60077.12006-.83844.85144-.42297,1.3017l1.90161,2.06079-.32715,2.78497c-.07147.60846.55072,1.06049,1.1073.8045l2.54755-1.17169,2.54755,1.17169c.55664.25598,1.17877-.19604,1.1073-.8045l-.32709-2.78497,1.90161-2.06079c.41541-.45026.1778-1.18164-.42297-1.3017Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M68.80359,35.28534l-2.74969-.5495-1.37231-2.44537c-.29987-.53424-1.06891-.53424-1.36871,0l-1.37231,2.44537-2.74969.5495c-.60077.12006-.83844.85144-.42297,1.3017l1.90161,2.06079-.32715,2.78491c-.07147.60846.55072,1.06055,1.1073.8045l2.54755-1.17169,2.54761,1.17169c.55658.25604,1.17871-.19604,1.10724-.8045l-.32709-2.78491,1.90161-2.06079c.41547-.45026.1778-1.18164-.42297-1.3017Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M40.8092,35.28534l-2.74976-.5495-1.37231-2.44537c-.2998-.53424-1.06885-.53424-1.36865,0l-1.37231,2.44537-2.74976.5495c-.60071.12006-.83838.85144-.42291,1.3017l1.90155,2.06079-.32709,2.78491c-.07147.60846.55072,1.06055,1.1073.8045l2.54755-1.17169,2.54755,1.17169c.55658.25604,1.17877-.19604,1.1073-.8045l-.32709-2.78491,1.90155-2.06079c.41547-.45026.17786-1.18164-.42291-1.3017Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsContributorReviewsScraper);
export default __webpack_public_path__ + "static/media/google-maps-contributor-reviews-scraper.c1f14d2ccc5c382260dfa626b9ab146d.svg";
export { ForwardRef as ReactComponent };